import CommunicationViewDrawer from "./CommunicationViewDrawer";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {Button, Tooltip} from "antd";
import {capitalize} from "lodash";
import {EyeOutlined} from "@ant-design/icons";
import {AssetAddress} from "../../../types/api/getEventsResult";
import {getAssetAddress} from "../../../utils/assets";
import {useEventContext} from "../../../context/event/EventContext";
import {PaginationConfig} from "antd/lib/pagination";
import {skipToken} from "@reduxjs/toolkit/query";
import {useGetAssetCommunicationsPaginatedQuery} from "../../../redux/api/events";
import {CommunicationStatus} from "../../../types/api/communications";
import dayjs from "dayjs";
import {AssetTabs, CommunicationStatusTabs} from "./CommunicationTabs";

export default function AssetCommunicationView({asset}: { asset: AssetAddress }) {
  const {t} = useTranslation()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  // get communications list
  const {event} = useEventContext()
  const [pagination, setPagination] = useState<PaginationConfig>({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    showTotal: (total, range) => t('table.pageSizeOfTotal', {
      rangeStart: range[0],
      rangeEnd: range[1],
      total,
    }),
    onChange: (page, pageSize) => setPagination(prevPag => ({...prevPag, current: page, pageSize})),
    style: {textAlign: 'center', marginTop: '2rem'},
  });
  const [communicationStatusTab, setCommunicationStatusTab] = useState<AssetTabs>(CommunicationStatusTabs.sentAndReceived)
  const [datetimeBefore, setDatetimeBefore] = useState("")
  const [datetimeAfter, setDatetimeAfter] = useState("")

  const isParamsOk = isDrawerOpen && event?.uuid

  //get cluster communication
  const {data, isFetching, isUninitialized} = useGetAssetCommunicationsPaginatedQuery(
    isParamsOk ? {
        ...!!datetimeAfter && {datetime_after: datetimeAfter},
        ...!!datetimeBefore && {datetime_before: datetimeBefore},
        eventUuid: event?.uuid,
        assetUuid: asset.uuid,
        page: pagination.current,
        page_size: pagination.pageSize,
        status: communicationStatusTab === CommunicationStatusTabs.sentAndReceived ?
          [CommunicationStatus.received, CommunicationStatus.sent]   : [CommunicationStatus.draft],
      }
      : skipToken)

  return <>
    <CommunicationViewDrawer
      communicationTab={communicationStatusTab}
      tabs={{
        activeKey: communicationStatusTab,
        onChange: (value) => setCommunicationStatusTab(value as AssetTabs)
      }}
      list={{
        dataSource: data?.results,
        loading: isUninitialized || isFetching,
        ...!!data?.count && {
          pagination: {
            total: data?.count,
            ...pagination
          }
        }
      }}

      datePickerAfter={{
        value: datetimeAfter ? dayjs(datetimeAfter) : undefined,
        onChange: (v) => {
          setDatetimeAfter(v?.startOf('day').toISOString() || "")
        }
      }}
      datePickerBefore={{
        value: datetimeBefore ? dayjs(datetimeBefore) : undefined,
        onChange: (v) => {
          setDatetimeBefore(v?.endOf('day').toISOString() || "")
        }
      }}
      drawer={{
        open: isDrawerOpen,
        title: getAssetAddress(asset),
        onClose: () => setIsDrawerOpen(false)
      }}
    />
    <Tooltip
      title={capitalize(t('actions.viewItem', {item: t('events.communication', {count: 2})}))}
    >
      <Button
        onClick={() => setIsDrawerOpen(true)}
        icon={<EyeOutlined/>}
        type={'text'}
      />
    </Tooltip>
  </>
}